import { LoanProductCategory } from '@ilg-totallymoney/types'

import { clamp } from './clamp'
import { getCategoryLoanFilterLimits } from './getCategoryLoanFilterLimits'

interface Options {
    category: LoanProductCategory
    loanAmount?: string
    loanTerm?: string
}

export function getQueryCategoryLoanFilterValues(options: Options): {
    loanAmount: number
    loanTerm: number
} {
    const limits = getCategoryLoanFilterLimits(options.category)

    const loanDefaults = (() => {
        switch (options.category) {
            default: {
                return {
                    loanAmount: 4000,
                    loanTerm: 24,
                }
            }
        }
    })()

    let loanAmount = Number(options.loanAmount ?? loanDefaults.loanAmount)
    let loanTerm = Number(options.loanTerm ?? loanDefaults.loanTerm)

    return {
        loanAmount: clamp(
            loanAmount,
            limits.loanAmount.min,
            limits.loanAmount.max
        ),
        loanTerm: clamp(loanTerm, limits.loanTerm.min, limits.loanTerm.max),
    }
}
